import { createFileRoute } from '@tanstack/react-router'
import { LOGISTICS_VEHICLE_ADD } from '~/components/routes/logistics/tabs'
import { LogisticsRecordRoute } from '~/components/routes/logistics/logistics-record-page'
import { VehiclePage } from '~/components/routes/logistics/vehicle-page'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsSearchSchema } from '../-search-schema'

export const Route = createFileRoute('/_authenticated/logistics/vehicles/new')({
  staticData: {
    permission: LOGISTICS_VEHICLE_ADD,
  },
  component: NewVehicleRoute,
  validateSearch: logisticsSearchSchema,
})
withRoutePermissions(Route)

function NewVehicleRoute() {
  return (
    <LogisticsRecordRoute
      tab="vehicles"
      search={Route.useSearch()}
      permission={LOGISTICS_VEHICLE_ADD}
    >
      {(search) => <VehiclePage vehicleId={null} search={search} />}
    </LogisticsRecordRoute>
  )
}
